module.exports = __webpack_public_path__ + "static/img/share.f5c06ce8.png";